<template>
  <div class="publicItems">
    <div class="selectionArea">
      <!-- <div class="item">
        <span class="title">请输入部门id:</span>
        <el-input
          v-model="parameter.department_id"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div> -->
      <!-- <div class="item">
        <span class="title">广告主名称:</span>
        <el-input
          v-model="parameter.account_name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <div class="item">
        <span class="title">广告主标签:</span>
        <el-input
          v-model="parameter.account_tag"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div> -->
      <!-- <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button> -->
      <el-button
        type="primary"
        icon="el-icon-circle-plus"
        @click="func"
      >添加</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%;margin-top: 20px;"
      >
        <el-table-column
          prop="id"
          label="id"
          align="center"
        />
        <el-table-column
          prop="name"
          label="部门名称"
          align="center"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          align="center"
        />
        <el-table-column
          label="操作"
          min-width="150"
          align="center"
        >
          <template scope="scope">
            <el-button type="primary" @click="modify(scope.row)">修改</el-button>
            <el-button type="danger" @click="myDelete(scope.row)">删除</el-button>
            <el-button type="warning" @click="(drawer = true),(drawerItem = scope.row)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="'部门管理'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="40%"
    >
      <iaadepartmentdialog
        ref="iaadepartmentview"
        @updatawe="updatawe"
      />
    </el-dialog>
    <el-drawer
      ref="drawer"
      title="详情"
      :visible.sync="drawer"
      :with-header="false"
      size="60%"
    >
      <Details v-if="drawer" :drawer-item="drawerItem" @close="$refs.drawer.closeDrawer()" />
    </el-drawer>
  </div>
</template>

<script>
import { iaadepartmentdestroy, iaaMaterialReportdepartmentlist } from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import iaadepartmentdialog from './components/iaadepartmentdialog.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    iaadepartmentdialog,
    Details
  },
  data() {
    return {
      tableData: {},
      data: [],
      loading: false,
      parameter: {
        page: 1,
        page_size: 10
        // department_id: ''
      },
      dialogVisible: false,
      drawer: false,
      drawerItem: {}
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await iaaMaterialReportdepartmentlist(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    func() {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.iaadepartmentview.send(1)
      }, 100)
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10
        // name: null
      }
      this.getDataList()
    },

    // 删除
    myDelete(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await iaadepartmentdestroy({ id: row.id })
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    updatawe() {
      this.dialogVisible = false
      this.getDataList()
    },
    modify(item) {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.iaadepartmentview.send(2, item)
      }, 100)
    }
  }
}
</script>
<style scoped>
.publicItems{
  padding: 20px;
}
.selectionArea {
  display: flex;
}

.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .item_title {
      display: inline-block;
      width: 100px;
    }

    .item_input {
      width: 200px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>
